import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { findClientById } from "../../poll/selectors";
import DisplayHtml from "../html/DisplayHtml";

class ClientPaymentMethod extends React.Component {
	render() {
		return <DisplayHtml value={this.props.client.PaymentNote} />;
	}
}

ClientPaymentMethod.propTypes = {
	clientId: PropTypes.number.isRequired
};

const mapStateToProps = (state, props) => {
	return {
		client: findClientById(state, props.clientId)
	};
};

export default connect(mapStateToProps)(ClientPaymentMethod);
